import React from 'react';
import { Badge } from 'react-bootstrap';
import { AmlCase } from './types';
import { formatAmount } from './amlUtils';

interface Props {
  amlCase: AmlCase;
}

// Краткий профиль пользователя в контексте AML
const AmlUserProfile: React.FC<Props> = ({ amlCase }) => {
  const kycBadge = (status?: string) => {
    switch (status) {
      case 'approved': return <Badge bg="success">Подтверждён</Badge>;
      case 'pending':  return <Badge bg="warning" text="dark">В процессе</Badge>;
      case 'rejected': return <Badge bg="danger">Отклонён</Badge>;
      default:         return <Badge bg="secondary">Не начат</Badge>;
    }
  };

  const rows: { label: string; value: React.ReactNode }[] = [
    { label: 'ID пользователя',   value: <code>{amlCase.userId}</code> },
    { label: 'Email',             value: amlCase.userEmail || '—' },
    { label: 'Имя',               value: amlCase.userName || '—' },
    { label: 'Телефон',           value: amlCase.userPhone || '—' },
    { label: 'Страна',            value: amlCase.country || '—' },
    { label: 'KYC-статус',        value: kycBadge(amlCase.kycStatus) },
    {
      label: 'Возраст аккаунта',
      value: amlCase.accountAge != null
        ? `${amlCase.accountAge} дн.`
        : '—'
    },
    {
      label: 'Транзакции (30 дн.)',
      value: amlCase.totalTransactions30d != null
        ? amlCase.totalTransactions30d
        : '—'
    },
    {
      label: 'Оборот (30 дн.)',
      value: amlCase.totalVolume30d != null
        ? formatAmount(amlCase.totalVolume30d, 'RUB')
        : '—'
    },
  ];

  return (
    <table className="table table-sm table-borderless mb-0">
      <tbody>
        {rows.map((row) => (
          <tr key={row.label}>
            <td className="text-muted pe-3" style={{ fontSize: '0.85rem', whiteSpace: 'nowrap' }}>
              {row.label}
            </td>
            <td style={{ fontSize: '0.85rem' }}>{row.value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default AmlUserProfile;
